import { AfterViewInit, Component, OnDestroy, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DatePickerPresets, GlobalFunctions, imagePath, imgTypes } from '@global/GlobalFunctions';
import { ActionsDataService } from '@services/actions-data.service';
import { AssetsDataService, LevelAsset } from '@services/assets-data.service';
import { AuthenticationService, WebAppUser } from '@services/authentication.service';
import { combineLatest, distinctUntilChanged, filter, finalize, firstValueFrom, Subject, take, takeUntil, tap } from 'rxjs';
import { siteSubscriptions } from '@services/siteSubscriptions';
import { OrganisationsHierarchy } from '@services/organisation-data.service';
import { Account } from '@services/accounts.service';
import { DropDownList } from '@syncfusion/ej2-angular-dropdowns';
import { AxisModel, ChartComponent, SeriesModel } from '@syncfusion/ej2-angular-charts';
import { AssetDataPoint, DataPoint, ISensorData } from '@services/datapoints-data.service';
import { convertEpochToDateString } from '@functions/functions';
import { MatCheckbox } from '@angular/material/checkbox';
import { __core_private_testing_placeholder__ } from '@angular/core/testing';
import { Browser } from '@syncfusion/ej2-base';

export class ComparisonStatistic {
	datapoint: AssetDataPoint;
	max: number;
	min: number;
	sampleCount: number;
	average?: number;
	difference?: number;
}

@Component({
	selector: 'app-asset-comparison',
	templateUrl: './asset-comparison.component.html',
	styleUrls: ['./asset-comparison.component.scss']
})
export class AssetComparisonComponent implements AfterViewInit, OnDestroy {

	/** Path to Assets Images */
	public imagePathAssets(): string {
		return imagePath(this.selectedAccountUID, imgTypes.organisationassets).toLowerCase()
	}

	/** Observable Subject Finalise */
	private finalise = new Subject<void>();

	/** Selected Account ID */
	public selectedAccountUID: string = ""

	/** Selected Organisation ID */
	public selectedOrganisationUID: string = ""

	/** hierarchicalData */
	public hierarchicalData: OrganisationsHierarchy[];

	/** currentUser */
	public currentUser: WebAppUser;

	/** account */
	public account: Account;

	/** assetList */
	public assetList: LevelAsset[] = [];

	/** filteredAssetList */
	public filteredAssetList1: LevelAsset[] = [];

	/** filteredAssetList */
	public filteredAssetList2: LevelAsset[] = [];

	/** assetFields */
	public assetFields: { text: string, value: string } = { text: "Name", value: "AssetID" };

	/** dropdown1 */
	@ViewChild('dropdown1') dropdown1: DropDownList;

	/** dropdown2 */
	@ViewChild('dropdown2') dropdown2: DropDownList;

	/** selectedAsset1 */
	public selectedAsset1: LevelAsset;

	/** selectedAsset2 */
	public selectedAsset2: LevelAsset;

	/** queryParams */
	public queryParams: Params;

	/** MainLocations */
	public MainLocations: OrganisationsHierarchy[] = [];

	/** locationFields */
	public locationFields: { text: string, value: string } = { text: "Name", value: "Id" };

	/** selectedLocation */
	public selectedLocation?: OrganisationsHierarchy;

	/** locationDropdown */
	@ViewChild('dropdown') locationDropdown: DropDownList;

	/** Chart Zoom Settings */
	public zoomSettings: Object;
	/** Sensor X Axis */
	public sensorXAxis: Object;
	/** Sensor Y Axis */
	public sensoryAxis: object;
	/** Sensor Y Average Axis */
	public sensoryAxis_Avg: object
	/** Chart Legend */
	public legend: Object;
	/** Sensor Data Label */
	public dataLabels: Object;
	/** Tooltip Settings */
	public tooltipSettings: Object;
	/** Chart boarder Settings */
	public borderSettings: Object;

	/** crosshair */
	public crosshair: object = {
		enable: true,
		lineType: 'Vertical'
	};

	/**
	 * Chart Selection mode
	 * None|Point|Series|Cluster|DragXY|DragX|DragY
	 */
	public selectionMode: string;

	/** Sensor pen Pallet Colours */
	public palette: object;

	/** chartWidth */
	public chartWidth: string = "950px";
	/** chartHeight */
	public chartHeight: string = "400px";

	/** width of graph window in hours */
	public windowWidth: number = 12;

	/** My Chart */
	@ViewChild('myChart2') public myChart: ChartComponent;

	/** Spinner */
	public spinner: boolean

	/** assetDatapoints1 */
	public assetDatapoints1: AssetDataPoint[] = [];

	/** assetDatapoints2 */
	public assetDatapoints2: AssetDataPoint[] = [];

	/** primaryMax */
	public primaryMax: number = 0;
	/** secondaryMax */
	public secondaryMax: number = 0;

	/** parsedData */
	public parsedData: ISensorData[] = [];

	/** seriesColours */
	public seriesColors: { datapointID: number, color: string }[] = [];

	private lightGreenCyan: string = "#00E1B3";         // Lighter green/cyan color
	private lightGreenCyanDarker1: string = "#02735c";  // Noticeably darker version of light green/cyan
	private lightGreenCyanDarker2: string = "#005244";  // Even darker version of light green/cyan

	private darkBlue: string = "#3366FF";               // Slightly lighter dark blue color
	private darkBlueDarker1: string = "#022073";        // Darker version of dark blue
	private darkBlueDarker2: string = "#010b2b";        // Even darker version of dark blue

	// Predefined array of default colors
	private defaultColors: string[] = [
		"#FF5733", // Red
		"#33FF57", // Green
		"#3357FF", // Blue
		"#F0E130", // Yellow
		"#FF33F0", // Pink
		"#33FFF6", // Aqua
		"#FF9833", // Orange
		"#F633FF", // Purple
		"#8BFF33"  // Light Green
	];

	// Variable to track the next default color to use
	private defaultColorIndex: number = 0;

	/** chartOnly */
	public chartOnly: boolean = false;

	/** datapoint1Checkboxes */
	@ViewChildren('assetDatapoints1Checkbox') datapoint1Checkboxes: any;

	/** datapoint2Checkboxes */
	@ViewChildren('assetDatapoints2Checkbox') datapoint2Checkboxes: any;

	// /** Define the Time Selection Buttons */
	// public chipDurations = [
	// 	// { time: "00:00:30", text: "30m", toolTip: "30 Minutes" },
	// 	// { time: "00:01:00", text: "1h", toolTip: "1 Hour" },
	// 	// { time: "00:02:00", text: "2h", toolTip: "2 Hours" },
	// 	// { time: "00:04:00", text: "4h", toolTip: "4 Hours" },
	// 	{ time: "00:08:00", text: "8h", toolTip: "8 Hours" },
	// 	{ time: "00:12:00", text: "12h", toolTip: "12 Hours" },
	// 	{ time: "01:00:00", text: "1d", toolTip: "1 Day" },
	// 	{ time: "02:00:00", text: "2d", toolTip: "2 Days" },
	// 	{ time: "07:00:00", text: "7d", toolTip: "7 Days" },
	// 	{ time: "30:00:00", text: "30d", toolTip: "30 Days" },
	// 	{ time: "60:00:00", text: "60d", toolTip: "60 Days" },
	// 	{ time: "90:00:00", text: "90d", toolTip: "90 Days" }
	// ];

	/** strDuration */
	public strDuration: string = '00:12:00'; //'';

	/** visibleStartDate */
	public visibleStartDate: Date;
	/** visibleEndDate */
	public visibleEndDate: Date;

	/** Define start date */
	public startDate: Date;
	/** Define end date */
	public endDate: Date;

	/** shortMonths */
	private shortMonths: string[] = [
		"Jan", "Feb", "Mar", "Apr", "May", "Jun",
		"Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
	];

	/** datapointSIs */
	public datapointSIs: { SI: string, enabled: boolean }[] = [];

	/** datapoint2Checkboxes */
	@ViewChildren('siCheckbox') siCheckboxes: any;

	/** statistics */
	public statistics: ComparisonStatistic[] = [];

	/** cumulativeStatistics */
	public cumulativeStatistics: ComparisonStatistic[] = [];


	/** filteredStatistics */
	public filteredStatistics: ComparisonStatistic[] = [];

	/** fields */
	public fields: { text: string, value: string } = { text: "datapoint.DPTitle", value: "datapoint.DatapointID" };

	/** selectedAssets */
	public selectedAssets: any[] = ['selection', 'selection'];

	/** defaultValue */
	public defaultValue: boolean = true;

	/** maxMonths */
	private maxMonths: number = 36;

	/** shouldAddSecondXAxis */
	public shouldAddSecondXAxis: boolean = false;

	/** regex */
	public regex = /^\[[0-9]*\]$/;

	/** regexDelta */
	public regexDelta = /^\[[0-9]*_DELTA\]$/;

	/** barData */
	public barData: { datapointID: any, data: ISensorData[], min: number, max: number, rawData?: ISensorData[] }[] = [];

	/** calculatedData */
	public calculatedData: { datapointID: any, min: number, max: number, data: ISensorData[] }[] = [];

	/** rawData */
	public rawData: { datapointID: any, min: number, max: number, data: ISensorData[] }[] = [];

	/** includesCumulativeDatapoints */
	public includesCumulativeDatapoints: boolean = false;

	/** showBars */
	public showBars: boolean = false;

	/** comparingAssets */
	public comparingAssets: LevelAsset[] = [];

	/** assetDataPoints */
	public assetDataPoints: AssetDataPoint[][] = [];

	/** dropdowns */
	@ViewChildren('assetDropdown') dropdowns: QueryList<DropDownList>;

	/** dataPointValues */
	public dataPointValues: ISensorData[][] = [];

	/** plottedDatapoints */
	public plottedDatapoints: AssetDataPoint[] = [];

	/** comparing */
	public comparing: boolean = false;

	/** datapointCheckboxes */
	@ViewChildren('datapointCheckbox') datapointCheckboxes: QueryList<MatCheckbox>;

	/** today - #71 */
	public today: Date = new Date();

	/** datePickerPresets - #71 */
	public datePickerPresets = DatePickerPresets;

	/**
	 * Default Constructor
	 * @param route route
	 * @param router router
	 * @param assetsDataService assetsDataService
	 * @param siteSubscriptions siteSubscriptions
	 * @param actionsDataService actionsDataService
	 * @param dialog dialog
	 * @param authenticationService authenticationService
	 * @param globalFunctions globalFunctions
	 */
	constructor(
		private route: ActivatedRoute,
		private router: Router,
		public assetsDataService: AssetsDataService,
		public siteSubscriptions: siteSubscriptions,
		public actionsDataService: ActionsDataService,
		public dialog: MatDialog,
		private authenticationService: AuthenticationService,
		private globalFunctions: GlobalFunctions,
	) {
		// this.globalFunctions.displaySpinner(true);
		combineLatest([
			this.authenticationService.currentUser$.pipe(takeUntil(this.finalise), distinctUntilChanged()),
			this.route.queryParams.pipe(takeUntil(this.finalise), distinctUntilChanged()),
			this.route.paramMap.pipe(takeUntil(this.finalise), distinctUntilChanged()),
			this.siteSubscriptions.hierarchicalData$.pipe(takeUntil(this.finalise), distinctUntilChanged())
		]).pipe(
			// Ensure that subscriptions are not null or undefined
			filter(([currentUser, queryParams, paramMap, hierarchicalData]) =>
				!!currentUser && !!paramMap && !!queryParams && !!hierarchicalData)
		).subscribe({
			next: async ([currentUser, queryParams, paramMap, hierarchicalData]) => {

				let [selectedAccount, selectedAccountGUID, selectedOrganisation, selectedOrganisationUID] = await firstValueFrom(
					combineLatest([
						this.siteSubscriptions.selectedAccount$.pipe(take(1)),
						this.siteSubscriptions.selectedAccountGUID$.pipe(take(1)),
						this.siteSubscriptions.selectedOrganisation$.pipe(take(1)),
						this.siteSubscriptions.selectedOrganisationUID$.pipe(take(1))
					]
					)
				);

				this.selectedAccountUID = selectedAccountGUID;
				this.account = selectedAccount;
				this.account = this.siteSubscriptions.normalizeFeatures(this.account) as Account;
				this.selectedOrganisationUID = selectedOrganisationUID;

				let urlAccountID = this.router.url.split('/')[1];

				if (this.selectedAccountUID.toLowerCase() != urlAccountID.toLowerCase() && this.router.url.includes('compare') && !this.router.url.includes('routing#')) {
					this.router.navigateByUrl(`routing#${this.router.url}`);
				}

				this.currentUser = currentUser;
				this.hierarchicalData = JSON.parse(hierarchicalData);

				this.assetList = this.flattenAssets(this.hierarchicalData);
				this.filteredAssetList1 = this.assetList;
				this.filteredAssetList2 = this.assetList;

				this.applyLocationFiltering();

				this.queryParams = queryParams;

				this.MainLocations = [];

				if (this.hierarchicalData[0].SubChild) {
					this.hierarchicalData[0].SubChild.forEach(subchild => {
						this.MainLocations.push(subchild);
					});
				}

				this.zoomSettings = {
					mode: 'X',
					// enableMouseWheelZooming: true,
					enablePinchZooming: true,
					enableSelectionZooming: true,
					enableScrollbar: true
				};
				this.tooltipSettings = {
					enable: true,
					// shared: true // Enables shared tooltip
				};
			},
			error: (error) => {
				this.globalFunctions.HandleError(error, "Error: Error in one of the combined subscriptions", false);
			}
		});
	}

	/**
	 * Page On Destroy Event Handler
	 */
	ngOnDestroy(): void {
		try {
			// Unsubscribe from all subscriptions
			this.finalise.next();
			this.finalise.complete();
		}
		catch { }
	}

	/**
	 * ngAfterViewInit
	 */
	ngAfterViewInit(): void {
		this.defaultValue = true;
		this.chartOnlyChange(this.defaultValue);
		if (!this.queryParams) {
			setTimeout(() => {
				this.ngAfterViewInit();
			}, 1);
		} else {
			if (!this.assetList) {
				setTimeout(() => {
					this.ngAfterViewInit();
				}, 1);
			}
			Object.entries(this.queryParams).forEach((param) => {
				if (param[0].includes("asset")) {
					const index = parseInt(param[0].replace("asset", ""));
					const asset = this.assetList.find((x: LevelAsset) => x.AssetID == param[1]);
					if (asset && !Number.isNaN(index)) {
						this.selectAsset({ itemData: asset }, index - 1);
					}
				}
			})
		}
	}

	/** Getting list of assets from an input hierarchy */
	flattenAssets(hierarchy: OrganisationsHierarchy[]): any[] {
		let result: any[] = [];

		// Check if hierarchy is a valid array before proceeding
		if (!Array.isArray(hierarchy)) {
			return result;
		}

		// Iterate over each item in the input hierarchy
		for (const item of hierarchy) {
			// Check if the item has a non-empty 'Asset' property
			if (item.Assets && item.Assets.length > 0) {
				result = result.concat(item.Assets);
			}

			// Recursively add all 'Asset' properties of the item's subchildren
			result = result.concat(this.flattenAssets(item.SubChild));
		}

		return result;
	}

	/**
	 * onFiltering
	 * @param event
	 */
	onFilteringAssets(event: any, index: number): void {
		event.cancel = true;
		const query = event.target.value.toLowerCase();
		this.applyLocationFiltering();
		const dropdown = this.dropdowns.find((x: DropDownList) => x.element.id === `${index}`);
		if (dropdown) {
			dropdown.showPopup();
			this.filteredAssetList1 = this.filteredAssetList1.filter(data => {
				const name = `${data.Name}`.toLowerCase();
				const description = `${data.Description}`.toLowerCase() || '';
				const combinedStr = `${name} - ${description}`;
				return combinedStr.includes(query);
			});
		}
	}

	/**
	 * selectAsset
	 * @param event event
	 * @param isFirst isFirst
	 */
	// selectAssetOLD(event: any, isFirst?: boolean) {
	// 	this.seriesColors = [];
	// 	if (this.myChart) {
	// 		this.myChart.clearSeries();
	// 	}
	// 	if (isFirst) {
	// 		this.selectedAsset1 = event.itemData;
	// 		if (this.selectedAsset1) {
	// 			this.rebuildURL(this.selectedAsset1.AssetID);
	// 		} else {
	// 			this.dropdown1.clear();
	// 			this.dropdown1.value = null;
	// 		}
	// 	} else {
	// 		this.selectedAsset2 = event.itemData;
	// 		if (this.selectedAsset2) {
	// 			this.rebuildURL(0, this.selectedAsset2.AssetID);
	// 		} else {
	// 			this.dropdown2.clear();
	// 			this.dropdown2.value = null;
	// 		}
	// 	}
	// 	if (this.selectedAsset1 && this.selectedAsset2) {
	// 		this.assetDatapoints1 = [];
	// 		this.assetDatapoints2 = [];
	// 		this.seriesColors = [];
	// 		this.defaultColorIndex = 0;
	// 		// this.getDataPoints(this.selectedAsset1, true);
	// 		this.setXAxis();
	// 		this.rebuildURL(this.selectedAsset1.AssetID, this.selectedAsset2.AssetID);
	// 	}
	// 	if (!this.selectedAsset1 && !this.selectedAsset2) {
	// 		this.rebuildURL();
	// 	}
	// }

	/**
	 * selectAsset
	 * @param event event  
	 */
	selectAsset(event: any, index: number) {
		// this.seriesColors = [];
		// if (this.myChart) this.myChart.clearSeries();
		if (!event.itemData) {
			//clear dropdown
			return;
		}
		this.comparingAssets[index] = event.itemData;
		this.rebuildURL();
		this.getDataPoints(this.comparingAssets[index], index);
	}

	/**
	 * View the Image Fullsize
	 * @param imageURL
	 */
	viewImage(imageURL: string) {
		this.globalFunctions.viewImageFullSize(imageURL);
	}

	/**
	 * findAsset
	 * @param assetID assetID
	 */
	findAsset(assetID: number): LevelAsset | undefined {
		let result: any = undefined;
		this.assetList.forEach(asset => {
			if (asset.AssetID == assetID) {
				result = asset;
			}
		});
		return result;
	}

	/**
	 * filterByLocation
	 * @param event event
	 * @param cancel cancel
	 */
	filterByLocation(event: any, cancel?: boolean) {
		if (cancel) {
			this.selectedLocation = undefined;
			this.locationDropdown.clear();
			this.dropdown1.clear();
			this.dropdown2.clear();
		} else if (event.itemData) {
			this.selectedLocation = <OrganisationsHierarchy>event.itemData;
		}
		this.applyLocationFiltering();
	}

	/**
	 * applyLocationFiltering
	 */
	applyLocationFiltering() {
		if (this.selectedLocation) {
			let locationAssets: LevelAsset[] = this.flattenAssets([this.selectedLocation]);
			let locationAssetIDs: number[] = [];
			locationAssets.forEach(asset => {
				locationAssetIDs.push(asset.AssetID);
			});
			this.filteredAssetList1 = this.assetList.filter((x: LevelAsset) => locationAssetIDs.includes(x.AssetID));
			this.filteredAssetList2 = this.filteredAssetList1;
			let d1Source: any = this.dropdown1.dataSource;
			if (!d1Source.some((item: any) => item.AssetID === this.dropdown1.value)) {
				this.dropdown1.value = null;
				this.dropdown1.clear();
				this.dropdown1.dataBind();
				this.dropdown1.refresh();
			}
			let d2Source: any = this.dropdown2.dataSource;
			if (!d2Source.some((item: any) => item.AssetID === this.dropdown2.value)) {
				this.dropdown2.value = null;
				this.dropdown2.clear();
				this.dropdown2.dataBind();
				this.dropdown2.refresh();
			}
		} else {
			this.filteredAssetList1 = this.assetList;
			this.filteredAssetList2 = this.assetList;
		}
	}

	/**
	 * Get Values for the DataPoints
	 * @param asset
	 * @param dateStart
	 * @param dateEnd
	 * @returns
	 */
	async GetDataPointValues(asset: LevelAsset, dateStart: any, dateEnd: any, index: number): Promise<boolean> {
		// Create a local Subject to control the subscription lifecycle
		const fetchDataSubject = new Subject<void>();

		if (this.myChart) {
			this.myChart.primaryXAxis.zoomFactor = 1;
			this.myChart.primaryXAxis.zoomPosition = 0;
		}

		this.datapointSIs.forEach(datapointSI => {
			datapointSI.enabled = true;
		});

		this.statistics = [];
		this.cumulativeStatistics = [];
		this.barData = [];
		this.calculatedData = [];

		return new Promise<boolean>((resolve, reject) => {
			this.assetsDataService.getAssetDataPointValues$(this.selectedAccountUID, this.selectedOrganisationUID, asset.AssetID, dateStart, dateEnd).pipe(
				takeUntil(fetchDataSubject), distinctUntilChanged(),
				// filter((dataPointValues) => !!dataPointValues),
				tap(() => {
				}),
				finalize(() => {
					// Ensure the subscription is terminated and the subject is completed
					fetchDataSubject.next();
					fetchDataSubject.complete();
					// this.displaySpinner(false);
					// this.filterStatistics();
				})
			).subscribe({
				next: (dataPointValues: any) => {
					try {
						let parsedData: ISensorData[]
						parsedData = dataPointValues.map((dataPointValue: any) => {
							return {
								//AssetId: dataPointValue.AssetID,
								AssetId: asset.AssetID,
								timestamp: dataPointValue.Timestamp,
								sampleDate: new Date(dataPointValue.Timestamp),
								...dataPointValue.Values,
								...Object.assign(
									{},
									...Object.entries(dataPointValue.DeltaValues).map(([key, value]: any) => {
										return { [key.replace("]", "") + "_DELTA" + "]"]: value };
									})
								),
								...Object.assign(
									{},
									...Object.entries(dataPointValue.DeltaTimestamps).map(([key, value]: any) => {
										return { [key.replace("]", "") + "_DELTA_TIME" + "]"]: value };
									})
								)
							}
						});

						parsedData.forEach((x: ISensorData) => {
							const DPID = parseInt(Object.entries(x).find((y) => this.regex.test(y[0]))?.[0].replace("[", "").replace("]", "") ?? "");
							if (DPID) {
								x[`[${DPID}_DELTA_CALCULATED]`] = (<number>this.getUsageValue(x, DPID)) ?? 0;
							}
						});

						this.parsedData = parsedData;
						this.dataPointValues[index] = parsedData;

						let assetDatapoints: AssetDataPoint[] = this.assetDataPoints[index];

						// Extract unique pairs of Si and Pv
						let uniqueDPPairs = [...new Set(assetDatapoints.map((x: DataPoint) => `${x.DataPointID},${x.SI},${x.EngMin},${x.EngMax}`))];
						// console.log(this.dataPoints)
						// let uniqueSIPairs = [...new Set(this.dataPoints.map((x: DataPoint) => `${x.SI},${x.PrimaryIndex}`))];
						let uniqueSIPairs = [
							...new Set(
								assetDatapoints
									.sort((a: DataPoint, b: DataPoint) => {
										const aPrimaryIndex = a.PrimaryIndex ? "true" : "false";
										const bPrimaryIndex = b.PrimaryIndex ? "true" : "false";
										return aPrimaryIndex.localeCompare(bPrimaryIndex) * -1;
									})
									.map((x: DataPoint) => `${x.SI},${x.PrimaryIndex}`)
							)
						];

						// parse the unique pairs back into separate Datapoints
						let uniqueDP = uniqueDPPairs.map((pair: any) => {
							let [dp, si, EngMin, EngMax] = pair.split(",");
							return { Dp: dp, Si: si, Max: EngMax, Min: EngMin };
						});

						// Calculate the Min and Max from the Actual Data based on the Datapoint						
						let calcMinMax = uniqueDP.map((DP: any, index) => {
							const values = parsedData
								.map(item => item[`[${DP.Dp}]`])
								.filter(value => typeof value === 'number') as number[];
							// Find the minimum value
							if (values.length != 0) {
								// This is commented out as it caused errors on long periods
								// DP.Min = Math.min(...values);
								// DP.Max = Math.max(...values);
								// This works around the issue
								DP.Min = values.reduce((min, val) => val < min ? val : min, values[0]);
								DP.Max = values.reduce((max, val) => val > max ? val : max, values[0]);
							} else {
								DP.Min = 0;
								DP.Max = 0;
							}
						});

						// parse the unique pairs back into separate Si and Pv values
						let uniqueSI = uniqueSIPairs.map((pair: any) => {
							let [si, primary] = pair.split(",");
							return { Si: si, Primary: primary };
						});

						// // parse the unique pairs back into separate Si and Pv values
						// let uniqueSI = uniqueSIPairs.map((pair: any) => {
						// 	let [si] = pair.split(",");
						// 	return { Si: si};
						// });

						this.myChart.primaryYAxis = {};

						this.myChart.axes = [];

						// Create axes for each unique unit
						let axes = uniqueSI.map((unit: any, index) => {

							// Calculate the Min and Max from the SI data in the chart
							let { min, max, interval } = this.findMinMaxForSi(uniqueDP, unit.Si);

							if (min == 0 && max == 1) {
								max = 2;
								interval = 1;
							}

							// Build Axis
							let axis: any = {
								// Assuming you want each axis to have a unique name based on the unit
								name: `Axis${unit.Si}`,
								// You can add more properties here if needed

								majorTickLines: { width: 0 },
								minorTickLines: { width: 0 },

								majorGridLines: { width: 0 },
								minorGridLines: { width: 0 },

								minimum: min,
								maximum: max, /** Let the Chart calculate the Max */

								interval: interval,//0.2,
								rowIndex: 1,
								lineStyle: { width: 1 },
								labelFormat: `{value} ${unit.Si}`,
							};

							// Set opposedPosition to true only for the none primary Value
							if (unit.Primary != 'true') {
								axis.opposedPosition = true;
								axis.rowIndex = 0;
							}
							return axis;
						});

						// this.myChart.primaryYAxis.visible=false;
						if (axes[0]) {
							axes[0].majorGridLines = { width: 1 };
							axes[0].opposedPosition = false;
							this.myChart.primaryYAxis = axes[0];

							//this.myChart.primaryXAxis.majorGridLines = { width: 0 };

							// Creating an array of the remaining elements of 'axes'
							let remainingAxes = axes.slice(1);
							// Assigning the remaining axes to the 'axes' property of 'myChart'
							this.myChart.axes = remainingAxes;

							this.addSecondXAxis();
						}

						// Clear previous series
						// this.myChart.clearSeries()

						// Add new Series
						assetDatapoints.forEach((dPoint: AssetDataPoint) => {
							const label: string = `[${dPoint.DataPointID}]`;
							if (!(dPoint.IsCumulative && dPoint.ShowDeltaValue)) {
								if (typeof (dPoint.DataPointID) == 'string') {
									const barData = this.calculateDeltaChartBarData(parsedData, label);
									const numArray = barData.map((x: ISensorData) => <number>x[label]);
									const max = Math.max(...numArray);
									const min = Math.min(...numArray);
									this.barData.push({
										datapointID: dPoint.DataPointID,
										data: barData,
										max: max,
										min: min,
										rawData: parsedData
									});
									const data = parsedData.map((x: ISensorData) => <number>x[`[${dPoint.DataPointID}_CALCULATED]`]);
									this.calculatedData.push({
										datapointID: `${dPoint.DataPointID}_CALCULATED`,
										max: Math.max(...data),
										min: Math.min(...data),
										data: parsedData
									});
								} else {
									const rawData = parsedData.map((x: ISensorData) => <number>x[label]).filter((x) => x != undefined);
									this.rawData.push({
										datapointID: `${dPoint.DataPointID}`,
										max: Math.max(...rawData),
										min: Math.min(...rawData),
										data: parsedData
									});
								}
								this.plotIfSelected(dPoint, index);
							}
							this.calculateStatistics(dPoint, index);
						});

						resolve(true);

					} catch (error) {
						console.error(error);
						reject(true);
					}
				},
				error: (error) => {
					this.globalFunctions.HandleError(error, "Error: this.AssetsDataService.getAssetDataPointValues$", false)
					reject(true);
				},
				//complete: () => { console.log("this.AssetsDataService.getAssetDataPointValues$.subscribe: Complete"); }
			});
		});
	}

	/**
	 * Show the Spinner
	 * @param show
	 */
	displaySpinner(show: boolean) {
		// this.globalFunctions.displaySpinner(show);
		this.spinner = show;
	}

	/**
	 * REturn the Axis scale Parameters
	 * @param data
	 * @param targetSi
	 * @returns
	 */
	findMinMaxForSi(data: any[], targetSi: string): { min: number | 0, max: number | 999, interval: number | 1 } {
		// Filter the array to include only objects where Si equals the targetSi
		const filtered = data.filter(item => item.Si.toLowerCase() === targetSi.toLowerCase());

		if (filtered.length === 0) {
			return { min: 0, max: 0, interval: 1 }; // No matching objects found
		}

		// Extract Min and Max values from the filtered objects
		const minValues = filtered.map(item => item.Min);
		const maxValues = filtered.map(item => item.Max);

		// Find the minimum and maximum values
		let min = Math.min(...minValues);
		let max = Math.max(...maxValues);

		min = Math.floor(min);
		max = Number(max.toFixed(1));
		let interval = ((max - min) / 13);
		if (interval > 1) {
			interval = Number(interval.toFixed(1));
			interval = Math.ceil(interval)
		} else { interval = this.roundToNearestTenth(interval); }

		max = max + interval;
		interval = (min == max) ? interval = 1 : interval

		return { min, max, interval };
	}

	/** Round to Nearest 10th */
	roundToNearestTenth(num: number): number {
		return Math.ceil(num * 10) / 10;
	}

	/** plotIfSelected */
	plotIfSelected(dPoint: AssetDataPoint, index: number) {
		let seriesColor = 'red';
		let existingColor: boolean = false;
		let findExistingColor = this.seriesColors.find((x) => x.datapointID == dPoint.DataPointID);
		if (findExistingColor && findExistingColor.color) {
			seriesColor = findExistingColor.color;
			existingColor = true;
		}
		if (!existingColor) {
			if (dPoint.SI == 'g') {
				// Check if lightGreenCyan has already been used
				if (this.seriesColors.some(s => s.color === this.lightGreenCyan)) {
					// If used, choose a darker shade
					if (this.seriesColors.some(s => s.color === this.lightGreenCyanDarker1)) {
						if (this.seriesColors.some(s => s.color === this.lightGreenCyanDarker2)) {
							seriesColor = this.defaultColors[this.defaultColorIndex];
							this.defaultColorIndex = (this.defaultColorIndex + 1) % this.defaultColors.length;
						} else {
							seriesColor = this.lightGreenCyanDarker2;
						}
					} else {
						seriesColor = this.lightGreenCyanDarker1;
					}
				} else {
					seriesColor = this.lightGreenCyan;
				}
			} else if (dPoint.SI.includes('C')) {
				// Check if darkBlue has already been used
				if (this.seriesColors.some(s => s.color === this.darkBlue)) {
					// If used, choose a darker shade
					if (this.seriesColors.some(s => s.color === this.darkBlueDarker1)) {
						if (this.seriesColors.some(s => s.color === this.darkBlueDarker2)) {
							seriesColor = this.defaultColors[this.defaultColorIndex];
							this.defaultColorIndex = (this.defaultColorIndex + 1) % this.defaultColors.length;
						} else {
							seriesColor = this.darkBlueDarker2;
						}
					} else {
						seriesColor = this.darkBlueDarker1;
					}
				} else {
					seriesColor = this.darkBlue;
				}
			} else {
				// If no specific condition is met, use the next color in the default array
				seriesColor = this.defaultColors[this.defaultColorIndex];

				// Increment the defaultColorIndex, and loop back to 0 if we reach the end of the array
				this.defaultColorIndex = (this.defaultColorIndex + 1) % this.defaultColors.length;
			}
		}
		let seriesName = dPoint.SI == '' ? dPoint.DPTitle : `${dPoint.DPTitle} (${dPoint.SI})`;
		if (typeof (dPoint.DataPointID) == "number") {
			this.myChart.addSeries([{
				animation: {
					enable: false
				},
				emptyPointSettings: { mode: "Drop" },
				type: 'Line',
				dataSource: this.dataPointValues[index],
				name: seriesName,
				xName: 'timestamp',
				yName: `[${dPoint.DataPointID}]`,
				marker: {
					visible: false,
					width: 8,
					height: 8,
					shape: 'Triangle',
					dataLabel: { "name": 'x' },
					isFilled: true
				},
				yAxisName: `Axis${dPoint.SI}`,
				fill: seriesColor
			}]);
		} else if (typeof (dPoint.DataPointID) == "string" && dPoint.DataPointID.includes("_DELTA")) {
			const label: string = this.showBars ? `[${dPoint.DataPointID}]` : `[${dPoint.DataPointID}_CALCULATED]`;
			const barData = this.barData.find((x) => x.datapointID == dPoint.DataPointID);
			if (this.showBars && !barData) {
				return;
			}
			this.myChart.addSeries([{
				animation: {
					enable: false
				},
				emptyPointSettings: { mode: "Drop" },
				type: this.showBars ? "Column" : "Line",
				dataSource: this.showBars ? barData!.data : this.dataPointValues[index],
				name: seriesName,
				xName: 'timestamp',
				yName: label,
				marker: {
					visible: false,
					width: 1,
					height: 8,
					shape: 'Triangle',
					dataLabel: { "name": 'x' },
					isFilled: true
				},
				yAxisName: `Axis${dPoint.SI}`,
				xAxisName: this.showBars ? "secondaryXAxis" : "primaryXAxis",
				fill: seriesColor,
				width: 1,
				columnWidth: 1,
				columnSpacing: 0.2,
				zOrder: this.showBars ? 0 : 1,
				opacity: this.showBars ? 0.75 : 1
			}]);
		}
		if (!existingColor) {
			this.seriesColors.push({
				datapointID: dPoint.DataPointID,
				color: seriesColor
			});
		}

		if (!this.primaryMax && this.myChart.primaryYAxis.interval) {
			this.primaryMax = <number>this.myChart.primaryYAxis.maximum;
			this.myChart.primaryYAxis.maximum = this.primaryMax + this.myChart.primaryYAxis.interval;
		} else {
			if (this.primaryMax < (<number>this.myChart.primaryYAxis.maximum) && this.myChart.primaryYAxis.interval) {
				this.primaryMax = <number>this.myChart.primaryYAxis.maximum;
				this.myChart.primaryYAxis.maximum = this.primaryMax + this.myChart.primaryYAxis.interval;
			}
		}

		if (this.myChart.axes[0] && this.myChart.axes[0].interval) {
			if (!this.secondaryMax) {
				this.secondaryMax = <number>this.myChart.axes[0].maximum;
				this.myChart.axes[0].maximum = this.secondaryMax + this.myChart.axes[0].interval;
			} else {
				if (this.secondaryMax < (<number>this.myChart.axes[0].maximum)) {
					this.secondaryMax = <number>this.myChart.axes[0].maximum;
					this.myChart.axes[0].maximum = this.secondaryMax + this.myChart.axes[0].interval;
				}
			}
		}

		this.updateCheckBoxes();
		this.checkAllSIEnabled();

		this.plottedDatapoints.push(dPoint);
	}

	/**
	 * getDataPoints
	 * @param asset asset
	 * @param isFirst isFirst
	 */
	getDataPoints(asset: LevelAsset, index: number) {
		const fetchDataSubject = new Subject<void>();

		// this.displaySpinner(true);

		// if (this.myChart) {
		// 	this.myChart.clearSeries();
		// }

		// this.strDuration = '00:12:00';

		this.assetsDataService.getAssetDataPoints$(this.selectedAccountUID, this.selectedOrganisationUID, asset.AssetID).pipe(
			takeUntil(fetchDataSubject), distinctUntilChanged(),
			filter((datapoints) => !!datapoints),
			finalize(() => {
				// Ensure the subscription is terminated and the subject is completed
				fetchDataSubject.next();
				fetchDataSubject.complete();
			})
		).subscribe({
			next: (datapoints) => {
				if (this.chartOnly) {
					datapoints = datapoints.filter((x: AssetDataPoint) => x.ShowOnChart);
				}
				datapoints.forEach((datapoint: AssetDataPoint) => {
					datapoint.SI = datapoint.SI.replace('%', '');
					if (datapoint.IsCumulative && datapoint.ShowDeltaValue) {
						this.includesCumulativeDatapoints = true;
						this.showBars = true;
						if (datapoint.SI != "kWh") {
							datapoints.push({
								...datapoint,
								DataPointID: parseInt(datapoint.DataPointID.toString()) + "_DELTA",
								SI: datapoint.SI + " (Delta)",
								PVName: datapoint.PVName + " - Delta",
								DPTitle: datapoint.DPTitle + " - Delta",
								PrimaryIndex: false,
								IsCumulative: false,
								ShowDeltaValue: false
							});
						} else {
							datapoints.push({
								...datapoint,
								DataPointID: parseInt(datapoint.DataPointID.toString()) + "_DELTA",
								SI: datapoint.SI + " (Usage)",
								PVName: datapoint.PVName + " - Usage",
								DPTitle: datapoint.DPTitle + " - Usage",
								PrimaryIndex: false,
								IsCumulative: false,
								ShowDeltaValue: false
							});
							this.shouldAddSecondXAxis = true;
						}
					}
				});
				this.assetDataPoints[index] = datapoints;
				this.pushSis();
				let end: number = new Date().getTime();
				let start: number = end - ((this.windowWidth) * 60 * 60 * 1000);
				// this.GetDataPointValues(asset, start, end, index);
			}
		});
	}

	/**
	 * convertEpoch
	 * @param epoch
	 * @returns
	 */
	convertEpoch(epoch: number): string {
		/** Use the Global Function */
		return convertEpochToDateString(epoch);
	}

	/**
	 * Add a section to the graph
	 * @param lines stripLine Definition
	 */
	setXAxis(lines: object[] = []): void {
		/* Sensor Graph specific variables */
		this.sensorXAxis = {
			// title: 'Date',
			valueType: "DateTime", //'Category',
			intervalType: parseInt(this.strDuration.split(":")[0]) > 2 || this.strDuration == 'custom' ? "Days" : "Hours",
			// intervalType: "Hours",
			// interval: 1,
			labelFormat: parseInt(this.strDuration.split(":")[0]) > 2 || this.strDuration == 'custom' ? "dd-MMM" : "HH:mm dd-MMM",
			// labelFormat: "HH:mm:ss dd-MMM",
			// labelIntersectAction: "Rotate45",
			// labelRotation: 35,
			// labelRotation: 90,
			// labelRotation: Browser.isDevice ? -45 : 0,
			majorTickLines: { visible: false },
			minorTickLines: { visible: false },
			majorGridLines: { visible: false },
			minorGridLines: { visible: false },
			// stripLines: lines
		};
	}

	/**
	 * getColor
	 * @param datapoint datapoint
	 */
	getColor(datapoint: AssetDataPoint): string {
		let result = this.seriesColors.find((x) => x.datapointID == datapoint.DataPointID)?.color ?? "";
		return result;
	}

	/**
	 * chartOnlyChange
	 * @param event event
	 */
	chartOnlyChange(event: boolean) {
		this.chartOnly = event;
		this.assetDatapoints1 = [];
		this.assetDatapoints2 = [];
		this.seriesColors = [];
		this.defaultColorIndex = 0;
		if (this.selectedAsset1 && this.selectedAsset2) {
			// this.getDataPoints(this.selectedAsset1, true);
		}
	}

	/** updateCheckBoxes */
	updateCheckBoxes() {
		if (this.myChart) {
			const datapoints: AssetDataPoint[] = [];
			this.assetDataPoints.forEach((arr: AssetDataPoint[]) => datapoints.push(...arr));
			this.datapointCheckboxes.forEach((x: MatCheckbox) => {
				const dp = datapoints.find((datapoint: AssetDataPoint) => `${datapoint.DataPointID}` == x.id);
				if (dp) {
					const series = this.myChart.series.find((x) => x.yName == (
						(typeof (dp.DataPointID) == 'string' && !this.showBars) ? `[${dp.DataPointID}_CALCULATED]` : `[${dp.DataPointID}]`));
					if (series) x.checked = series.visible ?? false;
				}
			});
		}
	}

	/**
	 * toggleCheckbox
	 * @param event event
	 * @param isFirst isFirst
	 */
	toggleCheckbox(event: any, datapoint: AssetDataPoint) {
		let checkboxSeries = this.myChart.series.find((x) => x.yName == (
			(typeof (datapoint.DataPointID) == 'string' && !this.showBars) ? `[${datapoint.DataPointID}_CALCULATED]` : `[${datapoint.DataPointID}]`));
		if (checkboxSeries) {
			checkboxSeries.visible = event.checked;
			// this.filterStatistics();
			this.myChart.dataBind();
			const scrollableDiv = document.getElementById('dockContent');
			const scrollX = scrollableDiv?.scrollLeft || 0;
			const scrollY = scrollableDiv?.scrollTop || 0;
			this.myChart.refresh();
			if (scrollableDiv) {
				scrollableDiv.scrollLeft = scrollX;
				scrollableDiv.scrollTop = scrollY;
			}
			this.checkAllSIEnabled();
		}
	}

	/**
	 * legendClick
	 * @param event event
	 */
	legendClick(event: any) {
		setTimeout(() => {
			this.updateCheckBoxes();
			this.checkAllSIEnabled();
		}, 10);
	}

	/**
	 * selectTime
	 */
	selectTime(sDuration: string) {
		this.strDuration = sDuration;
		this.compare();
	}

	/**
	 * redrawAxisScale
	 */
	redrawAxisScale() {
		if (this.myChart) {
			this.myChart.primaryYAxis.maximum = 0;
			this.myChart.axes[0].maximum = 0;
			let mins: number[] = [Infinity, Infinity];
			let maxs: number[] = [0, 0];
			this.plottedDatapoints.forEach((x: AssetDataPoint) => {
				const axis: number = x.PrimaryIndex ? 0 : 1;
				if (typeof (x.DataPointID) == 'string' && x.DataPointID.includes("_DELTA")) {
					if (this.showBars) {
						const barData = this.barData.find((y) => y.datapointID == x.DataPointID);
						if (barData) {
							mins[axis] = barData.min < mins[axis] ? barData.min : mins[axis];
							maxs[axis] = barData.max > maxs[axis] ? barData.max : maxs[axis];
						}
					} else {
						const calculatedData = this.calculatedData.find((y) => y.datapointID == `${x.DataPointID}_CALCULATED`);
						if (calculatedData) {
							mins[axis] = calculatedData.min < mins[axis] ? calculatedData.min : mins[axis];
							maxs[axis] = calculatedData.max > maxs[axis] ? calculatedData.max : maxs[axis];
						}
					}
				} else {
					const rawData = this.rawData.find((y) => y.datapointID == `${x.DataPointID}`);
					if (rawData) {
						mins[axis] = rawData.min < mins[axis] ? rawData.min : mins[axis];
						maxs[axis] = rawData.max > maxs[axis] ? rawData.max : maxs[axis];
					}
				}
			});
			if (mins[0] == Infinity) {
				mins[0] = mins[1] != Infinity ? mins[1] : 0;
			}
			if (mins[1] == Infinity) {
				mins[1] = mins[0] != Infinity ? mins[0] : 0;
			}
			if (maxs[0] == 0) {
				maxs[0] = maxs[1] != 0 ? maxs[1] : 100;
			}
			if (maxs[1] == 0) {
				maxs[1] = maxs[0] != 0 ? maxs[0] : 100;
			}
			mins = mins.map((min: number) => (min == Infinity || min < 0) ? 0 : min);
			maxs = maxs.map((max: number) => max == 0 ? 10 : max);
			const intervals: number[] = [
				(Math.max(maxs[0], <number>this.myChart.primaryYAxis.maximum) - Math.min(mins[0], <number>this.myChart.primaryYAxis.minimum)) / 10,
				(Math.max(maxs[1], <number>this.myChart.axes[0].maximum) - Math.min(mins[1], <number>this.myChart.axes[0].minimum)) / 10
			];
			this.myChart.primaryYAxis.minimum = Math.min(Math.max((mins[0] - intervals[0]), 0), <number>this.myChart.primaryYAxis.minimum);
			this.myChart.primaryYAxis.maximum = Math.max((maxs[0] + intervals[0]), <number>this.myChart.primaryYAxis.maximum);
			this.myChart.primaryYAxis.interval = intervals[0];
			this.myChart.axes[0].minimum = this.showBars ? 0
				: Math.min(Math.max((mins[1] - intervals[1]), 0), <number>this.myChart.axes[0].minimum);
			this.myChart.axes[0].maximum = Math.max((maxs[1] + intervals[1]), <number>this.myChart.axes[0].maximum);
			this.myChart.axes[0].interval = intervals[1];
			this.myChart.refresh();
		}
	}

	/**
	 * DatePickerChange
	 * @param event
	 */
	DatePickerChange(event: any) {
		try {
			// Validate the Date Range < 6 Months
			// Validate the Date Range < 6 Months
			const date1 = new Date(event.startDate.getTime());
			const date2 = new Date(event.endDate.getTime());

			const diffInMs = Math.abs(date2.getTime() - date1.getTime());
			const diffInMonths = diffInMs / (1000 * 60 * 60 * 24 * 30.44);

			if (diffInMonths < this.maxMonths) {
				/** Reset Duration Search */
				this.strDuration = "custom";
				this.startDate = event.startDate;
				this.endDate = event.endDate;
				this.endDate.setDate(this.endDate.getDate() + 1);
				this.compare();
			}
		}
		catch (error) { this.globalFunctions.HandleError(error, "DatePickerChange Error: Unknown", false) }
	}

	/** navigateByDuration */
	navigateByDuration(isForward: boolean) {
		let duration: string = "";
		let start: number = 0;
		let end: number = 0;
		if (this.strDuration) {
			duration = this.strDuration;
		}
		if (duration == "custom") {
			let difference: number = this.endDate.getTime() - this.startDate.getTime();
			if (!isForward) {
				end = this.startDate.getTime();
				start = end - difference;
			} else {
				start = this.endDate.getTime();
				end = start + difference;
				if (end > Date.now()) {
					end = Date.now();
					start = end - difference;
				}
			}
		} else {
			let difference: number = this.timeSpanToMilliseconds(duration);
			if (!isForward) {
				end = this.startDate.getTime();
				start = end - difference;
			} else {
				start = this.endDate.getTime();
				end = start + difference;
				if (end > Date.now()) {
					end = Date.now();
					start = end - difference;
				}
			}
		}
		this.compare();
	}

	/** timeSpanToMilliseconds */
	timeSpanToMilliseconds(timeSpan: string): number {
		// Split the string into components
		const [days, hours, minutes] = timeSpan.split(':').map(Number);

		// Validate the input
		if (isNaN(days) || isNaN(hours) || isNaN(minutes)) {
			throw new Error("Invalid time span format");
		}

		// Calculate the total milliseconds
		const milliseconds =
			(days * 24 * 60 * 60 * 1000) + // Days to milliseconds
			(hours * 60 * 60 * 1000) +     // Hours to milliseconds
			(minutes * 60 * 1000);         // Minutes to milliseconds

		return milliseconds;
	}

	/** getShortDate */
	getShortDate(date: Date): string {
		let result: string = "";
		result += date.getDate();
		result +=
			" " +
			this.shortMonths[date.getMonth()] +
			" " +
			date.getHours().toString().padStart(2, "0") +
			":" +
			date.getMinutes().toString().padStart(2, "0");

		return result;
	}

	/**
	 * onZoom
	 * @param event
	 */
	onZoom(event: any) {
		if (event.axis.orientation != 'Vertical') {
			if (event.currentZoomFactor != 1) {
				this.visibleStartDate = new Date(event.currentVisibleRange.min);
				this.visibleEndDate = new Date(event.currentVisibleRange.max);
			} else {
				this.visibleStartDate = this.startDate;
				this.visibleEndDate = this.endDate;
			}
		}
	}

	/**
	 * onScroll
	 * @param event
	 */
	onScroll(event: any) {
		if (event.axis.orientation != 'Vertical') {
			if (event.zoomFactor != 1) {
				this.visibleStartDate = new Date(event.range.min);
				this.visibleEndDate = new Date(event.range.max);
			} else {
				this.visibleStartDate = this.startDate;
				this.visibleEndDate = this.endDate;
			}
		}
	}

	/**
	 * checkClick
	 * @param event event
	 */
	checkClick(event: any) {
		if (event.target.toLowerCase().includes("zooming_reset")) {
			this.visibleStartDate = this.startDate;
			this.visibleEndDate = this.endDate;
		}
	}

	/**
	 * goToFunctionalLocation
	 * @param asset asset
	 */
	goToFunctionalLocation(asset: LevelAsset) {
		this.siteSubscriptions.SetSelectedAsset(asset);
		this.router.navigate([`/${this.selectedAccountUID}/organisation/${this.selectedOrganisationUID}/location/${asset.ParentUID}/asset/${asset.AssetID}`]);
	}

	/**
	 * pushSis
	 */
	pushSis() {
		const datapoints: AssetDataPoint[] = [];
		this.assetDataPoints.forEach((arr: AssetDataPoint[]) => datapoints.push(...arr));
		datapoints.forEach((datapoint: AssetDataPoint) => {
			let existingSI = this.datapointSIs.find((x) => x.SI == datapoint.SI || x.SI == datapoint.PVName);
			if (!existingSI) {
				this.datapointSIs.push({ SI: datapoint.SI || datapoint.PVName, enabled: true });
			}
		});
	}

	/**
	 * toggleSICheckbox
	 * @param event event
	 * @param si si
	 */
	toggleSICheckbox(event: any, si: string) {
		let datapointSI = this.datapointSIs.find((x) => x.SI == si);
		if (datapointSI) {
			datapointSI.enabled = event.checked;
		}
		this.updateSeriesSIVisibility();
	}

	/**
	 * updateSeriesSIVisibility
	 */
	updateSeriesSIVisibility() {
		this.myChart.series.forEach(series => {
			let si = series.name?.split(" ").pop()?.replace("(", "").replace(")", "");
			let datapointSI = this.datapointSIs.find((x) => x.SI == si);
			if (datapointSI) {
				series.visible = datapointSI.enabled;
				this.myChart.dataBind();
				this.myChart.refresh();
			}
		});
		setTimeout(() => {
			this.updateCheckBoxes();
		}, 10);
	}

	/**
	 * checkAllSIEnabled
	 */
	checkAllSIEnabled() {
		this.datapointSIs.forEach((dpSI) => {
			let datapoints: AssetDataPoint[] = [];
			this.assetDataPoints.forEach((x: AssetDataPoint[]) => datapoints.push(...x));
			datapoints = datapoints.filter((x: AssetDataPoint) => x.SI == dpSI.SI);
			const enabledState: boolean[] = this.myChart.series
				.filter((x: SeriesModel) =>
					datapoints.map((y: AssetDataPoint) => `[${y.DataPointID}]`)
						.includes(x.yName!)).map((x: SeriesModel) => x.visible ?? false);
			let result: boolean | undefined = undefined;
			let score: number = 0;
			enabledState.forEach((value: boolean) => score = value ? score + 1 : score - 1);
			if (enabledState.length == score) result = true;
			if ((enabledState.length * -1) == score) result = false;
			let checkbox: MatCheckbox = this.siCheckboxes.find((x: MatCheckbox) => x.id == dpSI.SI);
			if (checkbox && result != undefined) {
				checkbox.checked = result;
			}
		});
	}

	/**
	 * calculateStatistics
	 * @param datapoint datapoint
	 */
	calculateStatistics(datapoint: AssetDataPoint, index: number) {
		let result: ComparisonStatistic = {
			datapoint: datapoint,
			max: 99999,
			min: 0,
			sampleCount: 0
		}
		const data: number[] = this.dataPointValues[index].map((x: ISensorData) => <number>x[`[${datapoint.DataPointID}]`]).filter((x: number) => x != undefined && x != null);
		if (datapoint.IsCumulative) {
			result.max = parseFloat(Math.max(...data).toFixed(2));
			result.min = parseFloat(Math.min(...data).toFixed(2));
			result.difference = parseFloat((result.max - result.min).toFixed(2));
			result.sampleCount = data.length;
			this.cumulativeStatistics.push(result);
			return;
		} else if (typeof datapoint.DataPointID == 'string' && datapoint.DataPointID.includes("_DELTA")) {
			if (this.showBars) {
				const barData = this.barData.find((x) => x.datapointID == datapoint.DataPointID);
				if (barData) {
					result.max = parseFloat(barData.max.toFixed(2));
					result.min = parseFloat(barData.min.toFixed(2));
					result.sampleCount = barData.rawData ? barData.rawData.length : 0;
					const avg = (barData.data.map((x) => <number>x[`[${datapoint.DataPointID}]`]).reduce((sum, value) => sum + value, 0)) / (barData.data.length || 1);
					result.average = parseFloat(avg.toFixed(2));
				}
			} else {
				const calculatedData = this.calculatedData.find((x) => x.datapointID == `${datapoint.DataPointID}_CALCULATED`);
				if (calculatedData) {
					result.max = parseFloat(calculatedData.max.toFixed(2));
					result.min = parseFloat(calculatedData.min.toFixed(2));
					result.sampleCount = calculatedData.data.length;
					const avg = (calculatedData.data.map((x) => <number>x[`[${datapoint.DataPointID}_CALCULATED]`]).reduce((sum, value) => sum + value, 0)) / (calculatedData.data.length || 1);
					result.average = parseFloat(avg.toFixed(2));
				}
			}
		} else {
			let max: number = Math.max(...data);
			let min: number = Math.min(...data);
			let average: number = 0;
			let sampleCount: number = data.length;
			average = data.reduce((sum, value) => sum += value, 0);
			average /= sampleCount;
			result.max = parseFloat(max.toFixed(2));
			result.min = !min ? 0 : parseFloat(min.toFixed(2));
			result.average = Number.isNaN(average) ? 0 : parseFloat(average.toFixed(2));
			result.sampleCount = sampleCount;
		}
		this.statistics.push(result);
		this.filteredStatistics = this.statistics;
	}

	/**
	 * filterStatistics
	 */
	filterStatistics() {
		if (this.myChart) {
			let visibleSeries = this.myChart.series.filter((x: SeriesModel) => x.visible == true);
			let visibleDatapointIDs: number[] = [];
			let allDatapoints: AssetDataPoint[] = this.assetDatapoints1.concat(this.assetDatapoints2);
			allDatapoints.forEach(datapoint => {
				visibleSeries.forEach(series => {
					if (series.name?.includes(datapoint.DPTitle)) {
						visibleDatapointIDs.push(datapoint.DataPointID);
					}
				});
			});
			this.filteredStatistics = this.statistics.filter((x) => visibleDatapointIDs.includes(x.datapoint.DataPointID));
		}
	}

	/**
	 * asset2.AssetID
	 * @param asset1 asset1
	 * @param asset2 asset2
	 */
	rebuildURL(): void {
		let params: any = {};
		for (let i: number = 0; i < this.comparingAssets.length; i++) {
			params[`asset${i + 1}`] = this.comparingAssets[i].AssetID;
		}
		const url = this.router.createUrlTree([], { relativeTo: this.route }).toString();
		this.router.navigate([url], {
			queryParams: params,
			// queryParamsHandling: 'merge'
		});
	}

	/**
	 * clearSelection
	 * @param isFirst isFirst
	 */
	clearSelection(index: number) {
		//find dropdown and clear 
		let relevantDropdown = this.dropdowns.find((x) => x.element.id == `${index}`);
		if (relevantDropdown) {
			relevantDropdown.clear();
			relevantDropdown.value = null;
			relevantDropdown.dataBind();
			relevantDropdown.refresh();
		}
		this.removeAssetAtIndex(index);
		this.rebuildURL();
	}

	/**
	 * onTooltipRender
	 * @param args args
	 */
	onTooltipRender(args: any): void {
		if (typeof (args.data.pointX) != "string") {
			let timestamp: Date = args.data.pointX;
			const day = timestamp.getDate();
			const monthIndex = timestamp.getMonth();
			const minutes = timestamp.getMinutes();
			const hours = timestamp.getHours();
			const seconds = timestamp.getSeconds();
			const formattedDate = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')} ${day} ${this.shortMonths[monthIndex]}`;
			args.text = `${formattedDate} :${args.text.split(":").pop()}`;
		}
	}

	/**
	 * getUsageValue
	 * @param data data 
	 * @returns 
	 */
	getUsageValue(data: ISensorData, datapointID: number): number | undefined {
		let result = undefined;
		let deltaTimestamp = data[`[${datapointID}_DELTA_TIME]`];
		let deltaValue = data[`[${datapointID}_DELTA]`];
		let factor: number = 60 * 60 * 1000; //hour factor
		if (deltaTimestamp && (deltaValue != undefined)) {
			result = (factor / (<number>deltaTimestamp)) * <number>deltaValue;
		}
		return result;
	}

	/**
	 * addSecondXAxis
	 */
	addSecondXAxis() {
		const axis: AxisModel = {
			name: "secondaryXAxis",
			labelIntersectAction: "Wrap",
			valueType: 'Category',
			// intervalType: parseInt(this.strDuration.split(":")[0]) > 2
			// 	|| (this.strDuration == 'custom' && (this.endDate.getTime() - this.startDate.getTime() >= (3 * 24 * 60 * 60 * 1000)))
			// 	? "Days" : "Hours",
			// labelFormat: parseInt(this.strDuration.split(":")[0]) > 2
			// 	|| (this.strDuration == 'custom' && (this.endDate.getTime() - this.startDate.getTime() >= (3 * 24 * 60 * 60 * 1000)))
			// 	? "dd-MMM" : "HH:mm  dd-MMM",
			labelRotation: Browser.isDevice ? -45 : 0,
			opposedPosition: true,
			// labelFormat: this.myChart.primaryXAxis.labelFormat,
			// intervalType: this.myChart.primaryXAxis.intervalType
		}
		this.myChart.addAxes([axis]);
	}

	/**
	 * calculateDeltaChartBarData
	 * @param data data 
	 * @param label label 
	 * @returns 
	 */
	calculateDeltaChartBarData(data: ISensorData[], label: string): any[] {
		let result: any[] = [];
		let numWindows: number;
		let hourSeparator: boolean = false;
		const DAY = (24 * 60 * 60 * 1000);
		const HOUR = DAY / 24;
		let numDays: number;
		if (this.strDuration != "custom") {
			numDays = parseInt(this.strDuration.split(":")[0]) || parseInt(this.strDuration.split(":")[1]) / 24;
		} else {
			numDays = (this.endDate.getTime() - this.startDate.getTime()) / 1000 / 60 / 60 / 24;
		}
		numWindows = numDays > 2 ? numDays : numDays * 24;
		hourSeparator = numDays <= 2;

		for (let i: number = 0; i < numWindows; i++) {
			const startDateOnHour = new Date(this.startDate.getTime());
			startDateOnHour.setMinutes(0);
			startDateOnHour.setSeconds(0);
			let start: number = 0;
			if (this.strDuration != "custom") {
				start = startDateOnHour.getTime() + (!hourSeparator ? DAY * (i + 1) : HOUR * (i + 1));
			} else {
				start = i == 0 ? startDateOnHour.getTime() : startDateOnHour.getTime() + (!hourSeparator ? DAY * (i) : HOUR * (i));
			}
			const end = !hourSeparator ? start + DAY : start + HOUR;
			const windowData: number[] = data.filter((x: ISensorData) => x.timestamp > start && x.timestamp <= end).map((x: ISensorData) => <number>x[label]);
			let totalForWindow: number = 0;
			windowData.forEach((x: number) => totalForWindow += x);
			let timestamp = end - (!hourSeparator ? DAY / 2 : HOUR / 2);
			let tsDate: Date = new Date(timestamp);
			if (!hourSeparator) {
				tsDate.setHours(12);
			}
			tsDate.setMinutes(0);
			tsDate.setSeconds(0);
			// timestamp = tsDate.getTime();
			result.push({
				timestamp: this.getBarTimestamp(hourSeparator, start, end),
				sampleDate: new Date(timestamp).toString(),
				[label]: totalForWindow
			});
		}
		return result;
	}

	/**
	 * getBarTimestamp
	 * @param hourSeparator hourSeparator  
	 * @param start start 
	 * @param end end 
	 */
	getBarTimestamp(hourSeparator: boolean, start: number, end: number): string {
		let result: string = "";
		const startDate = new Date(start);
		const endDate = new Date(end);
		result = hourSeparator
			? `${startDate.getDate()} 
			${this.shortMonths[startDate.getMonth()]} 
			${startDate.getHours().toString().padStart(2, '0')}:00 
			- 
			${end <= new Date().getTime() ? endDate.getHours().toString().padStart(2, '0') + ':00' : 'Now'}`
			: `${startDate.toDateString()}`;
		return result;
	}

	/**
	 * toggleShowBars
	 * @param event event 
	 */
	toggleShowBars(event: any) {
		this.showBars = !this.showBars;
		let series: SeriesModel[] = this.myChart.series.filter((x: SeriesModel) => x.yName?.includes("_DELTA"));
		let yAxisName: string = "";
		series.forEach((series: SeriesModel) => {
			series.type = this.showBars ? "Column" : "Line";
			series.yName = this.showBars ? `${series.yName?.split("_")[0]}_DELTA]` : `${series.yName?.split("_")[0]}_DELTA_CALCULATED]`;
			const yName = series.yName;
			if (this.showBars) {
				const barData = this.barData.find((x) => x.datapointID == yName.replace("[", "").replace("]", ""));
				if (barData) {
					series.dataSource = barData.data;
				}
			} else {
				const calculatedData = this.calculatedData.find((x) => x.datapointID == yName.replace("[", "").replace("]", ""));
				if (calculatedData) {
					series.dataSource = calculatedData.data;
				}
			}
			series.xAxisName = this.showBars ? "secondaryXAxis" : "primaryXAxis";
			series.opacity = this.showBars ? 0.75 : 1;
			yAxisName = series.yAxisName ?? "";
			series.name = this.showBars ? series.name?.replaceAll("Running", "Usage") : series.name?.replaceAll("Usage", "Running");
		});
		this.redrawAxisScale();
		this.statistics = [];
		this.assetDataPoints.forEach((dps: AssetDataPoint[], index: number) => {
			dps.filter((x: AssetDataPoint) => !x.IsCumulative).forEach((x: AssetDataPoint) => this.calculateStatistics(x, index));
		});
		this.myChart.refresh();
	}

	/**
	 * compare
	 */
	async compare() {
		this.comparing = true;
		this.displaySpinner(true);
		this.myChart.clearSeries();
		this.plottedDatapoints = [];
		this.rawData = [];
		let end: number = 0;
		let start: number = 0;
		if (this.strDuration == "custom") {
			end = this.endDate.getTime();
			start = this.startDate.getTime();
		} else {
			const difference = this.timeSpanToMilliseconds(this.strDuration);
			end = new Date().getTime();
			start = end - difference;
			this.startDate = new Date(start);
			this.endDate = new Date(end);
		}
		this.visibleEndDate = this.endDate;
		this.visibleStartDate = this.startDate;
		const dataPromises = this.comparingAssets.map(async (x: LevelAsset, index: number) => {
			await this.GetDataPointValues(x, start, end, index);
		});
		await Promise.all(dataPromises);
		this.redrawAxisScale();
		this.setXAxis();
		this.displaySpinner(false);
	}

	/**
	 * removeAssetAtIndex
	 * @param index index 
	 */
	removeAssetAtIndex(index: number) {
		let assetArr: any[] = JSON.parse(JSON.stringify(this.comparingAssets));
		let dpArr: any[] = JSON.parse(JSON.stringify(this.assetDataPoints));
		let valArr: any[] = JSON.parse(JSON.stringify(this.dataPointValues));
		for (let i: number = index; i < assetArr.length; i++) {
			if (i == index) {
				assetArr[i] = null;
				dpArr[i] = null;
				valArr[i] = null;
			} else {
				assetArr[i - 1] = assetArr[i];
				dpArr[i - 1] = dpArr[i];
				valArr[i - 1] = valArr[i];
			}
		}
		assetArr.pop();
		dpArr.pop();
		valArr.pop();
		this.comparingAssets = assetArr;
		this.assetDataPoints = dpArr;
		this.dataPointValues = valArr;
		if (this.comparing) this.compare();
	}
}


